import styled from "styled-components";

export const AdditionalDetailsWrapper = styled.div`
  border-radius: 1em;
  ${"" /* margin: 1em 0; */}
  padding: 1em;
  box-shadow: 0 0 11px -1px rgb(229, 229, 229);

  .additional-form-input {
    flex: auto;
    width: 47%;
  }

  .additional-form-title {
    display: flex;
    gap: 0.5em;
    justify-content: center;
    margin-bottom: 1em;
  }

  .additional-form-img {
    margin-top: 2em;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1em;
    width: 100%;
    flex-direction: column;
  }

  .additional-form-img img {
    width: 25vmax;
    max-width: 270px;
  }

  .additional-details-card {
    display: flex;
    flex-direction: column;
    gap: 0.3em;
    color: #6b6b6b;
    width: 100%;
    border-radius: 1em;
    background: #fffbfb;
    border: 1px solid #ae8e68;
    padding: 1em;
    margin-top: 1em;
  }

  .additional-details-card > * {
    font-weight: 600;
  }

  .additional-details-card > div {
    display: flex;
    justify-content: space-between;
  }

  .check-details-line {
    padding-top: 15px;
    text-align: center;
    font-size: 14;
    color: #6b6b6b;
  }

  .additional-details-card > span + span {
    font-weight: normal;
    margin-bottom: 0.5em;
  }

  .heading {
    color: #c6222a;
    font-size: 16px;
  }

  .additional-confirm, .additional-confirm > * {
    display: flex;
    font-weight: normal;
    flex-direction: row;
    justify-content: space-between;
  }

  .sub-title {
    display: flex;
  }

  .radio-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  input[type="radio"] {
    height: 6px;
    padding: 6px;
    border-radius: 4px;
    background-color: #d9d9d9;
  }

  label {
    padding: 0 1rem;
    color: #6b6b6b;
  }

  input[type="radio"]:checked {
    background-color: #cb3443;
  }

  @media only screen and (max-width: 768px) {
    border-radius: 0;
    padding: 0;
    box-shadow: none;

    .additional-form-input {
      width: 100%;
    }

    .additional-form-input-small {
      max-width: 48%;
    }
  }
`;
